import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Button} from '@material-ui/core'
import {Link} from 'react-router-dom'
import GetAppIcon from '@material-ui/icons/GetApp';
import cv from './cv-najjar.pdf'
const useStyles = makeStyles(theme=>({
root:{
    background: 'orange',
   
    '&:hover': {
        background: "#FFC500",
        textDecoration: 'none',
        
    },
    borderRadius: '25px',
    width: '55%',
    margin: '4% auto',
    color: 'white',
    padding: '3%',
    [theme.breakpoints.down('md')]: {
        padding: '2%'

    },
    [theme.breakpoints.down('sm')]: {
        width: '50%',
    },
    
   
},
icon:{
    fontSize: '16px',
    marginLeft: '10px',
    border: '1px solid white',
    borderRadius: '20px',
    color: 'black',
    background: 'white'

}

}))
const LayoutBtn = () => {
    const classes = useStyles()
    return (
      
        <Link to={cv} target="_blank" className = {classes.root} download>
            Download Cv         
            <GetAppIcon className={classes.icon} />
        </Link>
           
    )
}

export default LayoutBtn
